// One place for the unknown→Error normalization every catch block needs
// (previously five hand-rolled variants across pages/hooks).

export function toError(err: unknown): Error {
  return err instanceof Error ? err : new Error(String(err));
}
